export default __webpack_public_path__ + "static/media/i_jestrab_lesni-min.ea7fe6ea.jpg";